var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTh = function SvgTh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A51931",
    d: "M12 22.9c6.02 0 10.9-4.88 10.9-10.9S18.02 1.1 12 1.1 1.1 5.98 1.1 12 5.98 22.9 12 22.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F8",
    d: "M19.8 4.4H4.2C2.3 6.3 1.1 9 1.1 12s1.2 5.7 3.1 7.6h15.6c1.9-2 3.1-4.7 3.1-7.6 0-3-1.2-5.7-3.1-7.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2A4A",
    d: "M1.1 12c0 1.4.3 2.8.8 4h20.3c.5-1.2.8-2.6.8-4s-.3-2.8-.8-4H1.9c-.5 1.2-.8 2.6-.8 4"
  })));
};
export default SvgTh;